import ActivitiesApplicationActions from "./ActivitiesApplicationActions";

const ActivitiesApplicationRow = ({ actividad, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{actividad.id}</td>
      <td
        dangerouslySetInnerHTML={{
          __html: highlightText(actividad.nombre || actividad.actividad || "-"),
        }}
      />
      <td>{actividad.talento_nombre || "-"}</td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            actividad.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {actividad.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <ActivitiesApplicationActions actividad={actividad} />
        </span>
      </td>
    </tr>
  );
};

export default ActivitiesApplicationRow;
